import {generateAsyncActionCreators} from '../core/reduxUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

const getCategoryProductsActionCreators = generateAsyncActionCreators(
  'GET_CATEGORY_PRODUCTS',
  (params, cookies, headers) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
    headers
  })
);

const getSeoInformationCategoryActionCreators = generateAsyncActionCreators(
  'GET_SEO_INFORMATION_CATEGORY',
  (params, cookies, headers) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
    headers
  })
);

const getCategoryRedirectionActionCreators = generateAsyncActionCreators(
  'GET_CATEGORY_REDIRECTIONS',
  (params) => ({
    params: {
      ...params,
    },
  })
);

const getNextCategoryProductsActionCreators = generateAsyncActionCreators(
  'GET_NEXT_CATEGORY_PRODUCTS',
  (params,cookies, headers) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
    headers
  })
);

const getIsGameConsoleActionCreators = generateAsyncActionCreators(
  'GET_IS_GAME_CONSOLE',
  (params) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.CATEGORY]: params[PAGINATION_PARAM_NAMES.CATEGORY],
    },
  })
);

const getCategoryInformationActionCreators = generateAsyncActionCreators(
  'GET_CATEGORY_INFORMATION',
  (categoryId, params) => ({
    categoryId,
    params,
  })
);

const getKeywordsActionCreators = generateAsyncActionCreators(
  'GET_KEYWORDS',
  (params) => ({
    params,
  })
);

const actionCreators = {
  getCategoryProducts: {
    ...getCategoryProductsActionCreators,
  },

  getSeoInformationCategory: {
    ...getSeoInformationCategoryActionCreators,
  },

  getCategoryRedirections: {
    ...getCategoryRedirectionActionCreators,
  },

  resetCategoryProducts() {
    return {
      type: 'RESET_CATEGORY_PRODUCTS',
      payload: {},
    };
  },

  getNextCategoryProducts: {
    ...getNextCategoryProductsActionCreators,
  },

  getIsGameConsole: {
    ...getIsGameConsoleActionCreators,
  },

  getCategoryInformation: {
    ...getCategoryInformationActionCreators,
  },

  getKeywords:{
    ...getKeywordsActionCreators,
  },

  resetCategoryPageState() {
    return {
      type: 'RESET_CATEGORY_PAGE_STATE',
      payload: {},
    };
  },
};

export {
  actionCreators,
  getCategoryProductsActionCreators,
  getSeoInformationCategoryActionCreators,
  getNextCategoryProductsActionCreators,
  getIsGameConsoleActionCreators,
  getCategoryInformationActionCreators,
  getCategoryRedirectionActionCreators,
  getKeywordsActionCreators
};
